module.exports = __webpack_public_path__ + "img/service3.38119a29.png";